import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: {},
};

export const userReducers = createSlice({
    name: "user",
    initialState,
    reducers: {
        authUser: (state, action) => {
            state.user = action.payload;
        },
    },
});

export const { authUser } = userReducers.actions;

export default userReducers.reducer;
